import { FormEvent } from "react"
import { Head, Link, useForm } from "@inertiajs/react"
import { useIntl } from "react-intl"
import { AuthShell } from "@/components/AuthShell"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

export default function PasswordNew() {
  const intl = useIntl()
  const form = useForm({ email: "" })
  const title = intl.formatMessage({ id: "auth.password_new.title" })
  const description = intl.formatMessage({ id: "auth.password_new.description" })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    form.post("/passwords")
  }

  return (
    <>
      <Head title={title}>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Head>
      <AuthShell>
        <h2 className="text-2xl">{title}</h2>
        <p className="mt-2">{intl.formatMessage({ id: "auth.password_new.intro" })}</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <label htmlFor="email">{intl.formatMessage({ id: "common.email" })}</label>
            <Input
              id="email"
              type="email"
              autoComplete="email"
              required
              value={form.data.email}
              onChange={(e) => form.setData("email", e.target.value)}
            />
          </div>
          <Button type="submit" disabled={form.processing}>
            {intl.formatMessage({ id: "auth.password_new.submit" })}
          </Button>
        </form>

        <p className="mt-6">
          <Link href="/login">{intl.formatMessage({ id: "auth.back_to_login" })}</Link>
        </p>
      </AuthShell>
    </>
  )
}
